let activeHandlers = 0;

export const registerEmbeddedDashboardHandler = () => {
  activeHandlers += 1;

  return () => {
    activeHandlers = Math.max(0, activeHandlers - 1);
  };
};

export const isEmbeddedDashboardHandlerActive = () => activeHandlers > 0;
